import ContactPatientQualificationCreator, {
  type IContactPatientQualificationCreatorProps
} from "../Components/ContactPatientQualificationCreator";
import useContactPatientQualification from "../hooks/useContactPatientQualification";
import AppContextValueProvider from "./AppContextValueProvider";

/** A {@link ContactPatientQualificationCreator} with qualification context injected from AppContext. */
const AppContextContactPatientQualificationCreator: React.FC = AppContextValueProvider<
  Omit<
    IContactPatientQualificationCreatorProps,
    "contactId" | "medicalForm" | "patient" | "useContactPatientQualification"
  >,
  IContactPatientQualificationCreatorProps
>({
  Component: ContactPatientQualificationCreator,
  map: ({ contactId, medicalForm, patient }) => ({
    contactId,
    medicalForm,
    patient,
    useContactPatientQualification
  })
}) as React.FC;

export default AppContextContactPatientQualificationCreator;
